import { z } from 'zod';

export const IdDescriptionItemSchema = z
    .object({
        id: z.string(),
        description: z.string().nullable(),
    })
    .strict();

export const UserExSchema = z
    .object({
        id: z.string(),
        fullName: z.string().nullable(),
        description: z.string().optional().nullable(),
        employeeSerialNumber: z.string().nullable().optional(),
        userName: z.string().nullable().optional(),
    })
    .strict();

export const ProvenanceExSchema = z
    .object({
        id: z.string(),
        description: z.string().nullable(),
        groupProvenance: IdDescriptionItemSchema,
    })
    .strict();

export const CommandSchema = z
    .object({
        bookingCanBeModified: z.boolean(),
        canBePreAdmmitted: z.boolean(),
        canBeAdmmitted: z.boolean(),
        canBeUndoAdmmitted: z.boolean(),
        canBeExecuted: z.boolean(),
        canBeUndoExecuted: z.boolean(),
        canBeModified: z.boolean(),
        canBeExamModified: z.boolean(),
        canBeAddedNewExam: z.boolean(),
        canBeDeleted: z.boolean(),
        canBeSuspended: z.boolean(),
        canBeUndoSuspended: z.boolean(),
        canBeReported: z.boolean(),
        canReportBeModified: z.boolean(),
        canBeApproved: z.boolean(),
        canBeUndoApproved: z.boolean(),
        canBeDigitallySigned: z.boolean(),
        canBeDeferred: z.boolean(),
        canBeDeferredAndDelete: z.boolean(),
        canCDBeCreated: z.boolean(),
        canQuestionListBeOpened: z.boolean(),
        canDraftBeOpened: z.boolean(),
        canReportBeOpened: z.boolean(),
        mustBeManualSentToWorklist: z.boolean(),
        isCollaborationActive: z.boolean(),
        canImagesBeViewed: z.boolean(),
        isMandatoryEquipmentChange: z.boolean(),
        canBePrintLabel: z.boolean(),
        canBeResigned: z.boolean(),
        canOpenConsultation: z.boolean(),
    })
    .strict();

export const IWorklistFeaDataSchema = z
    .object({
        hasPatientAuthorization: z.boolean(),
        isConsentValidated: z.boolean(),
    })
    .strict();

export const IWorklistAiDataSchema = z
    .object({
        alert: z.boolean(),
        clinicalApp: z.string().nullable(),
        score: z.string().nullable(),
        status: z.string().nullable(),
        scoreValue: z.number().nullable(),
    })
    .strict();

export const IWorklistPatientSchema = z
    .object({
        id: z.string(),
        sex: z.string().nullable(),
        sexCode: z.string().nullable(),
        taxCode: z.string().nullable(),
        birthDate: z.string().nullable(),
        race: z.string().nullable(),
        patientId: z.string(),
        issuer: z.string().nullable(),
        otherPatientId: z.string(),
        healthCard: z.string().nullable(),
        isAnonymous: z.boolean().nullable(),
        isMerged: z.boolean(),
        phone: z.string().nullable(),
        email: z.string().nullable(),
        birthPlace: z.string().nullable(),
        residenceProvince: z.string().nullable(),
        residenceCity: z.string().nullable(),
        residenceAddress: z.string().nullable(),
        residenceZipCode: z.string().nullable(),
        surname: z.string().nullable(),
        name: z.string().nullable(),
    })
    .strict();

export const BusinessUnitSchema = z
    .object({
        id: z.string(),
        description: z.string().nullable(),
        code: z.number(),
        publicationWeb: z.boolean().optional(),
        httpPacs: z.string().nullable(),
        isRemoteReportingSite: z.boolean().optional(),
        isRadiology: z.boolean().optional(),
        isToSendToCardio: z.boolean().optional(),
        isRxDensityMandatory: z.boolean().optional(),
    })
    .strict();

export const SeveritySchema = z
    .object({
        id: z.string(),
        description: z.string().nullable(),
        color: z.string().nullable(),
    })
    .strict();
